import React, { useState, useEffect } from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import images from '../../constants/images';
import './Navbar.css';

const Navbar = () => {
    const [toggleMenu, setToggleMenu] = useState(false);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [navbarVisible, setNavbarVisible] = useState(true);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            // Check if the hamburger menu is open
            if (toggleMenu) {
                // Keep the navbar visible if the menu is open
                setNavbarVisible(true);
            } else {
                // Hide or show the navbar based on scroll direction
                if (currentScrollY > lastScrollY) {
                    setNavbarVisible(false); // Scrolling down
                } else {
                    setNavbarVisible(true); // Scrolling up
                }
            }
            setLastScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY, toggleMenu]); // Include toggleMenu in the dependency array

    return (
        <nav className={`app__navbar ${navbarVisible ? '' : 'navbar--hidden'}`}>
            <div className="app__navbar-logo">
                <img src={images.mirodeliceLogo} alt="app__logo" />
            </div>
            <ul className="app__navbar-links">
                <li className="p__opensans"><a href="#home">Accueil</a></li>
                <li className="p__opensans"><a href="#about">À propos</a></li>
                <li className="p__opensans"><a href="#menu">Menu</a></li>
                <li className="p__opensans"><a href="#engagements">Engagements</a></li>
                <li className="p__opensans"><a href="#contact">Contact</a></li>
            </ul>
            <div className="app__navbar-smallscreen">
                <GiHamburgerMenu color="#fff" fontSize={27} onClick={() => setToggleMenu(true)} />
                {toggleMenu && (
                    <div className="app__navbar-smallscreen_overlay flex__center slide-bottom">
                        <img
                            src={images.chopstick}
                            alt="close menu"
                            className="overlay__close"
                            style={{filter: 'invert(0.5) sepia(1) saturate(5) hue-rotate(10deg)'}}
                            onClick={() => setToggleMenu(false)}

                        />
                        <ul className="app__navbar-smallscreen_links">
                            <li><a href="#home" onClick={() => setToggleMenu(false)}>Accueil</a></li>
                            <li><a href="#about" onClick={() => setToggleMenu(false)}>À propos</a></li>
                            <li><a href="#menu" onClick={() => setToggleMenu(false)}>Menu</a></li>
                            <li><a href="#engagements" onClick={() => setToggleMenu(false)}>Engagements</a></li>
                            <li><a href="#contact" onClick={() => setToggleMenu(false)}>Contact</a></li>
                        </ul>
                    </div>
                )}
            </div>
        </nav>
    );
};

export default Navbar;